
import * as moment from 'moment';
import 'moment/locale/zh-cn';

export const monthNames = [
  '一月', '二月', '三月', '四月', '五月', '六月',
  '七月', '八月', '九月', '十月', '十一月', '十二月',
];

export const dayNames = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

export const dayNamesShort = ['日', '一', '二', '三', '四', '五', '六'];

export const dateFormat = (value, patten = 'YYYY-MM-DD') => {
  if (value) {
    return moment(value).format(patten);
  }
  return '';
};

export const parseDate = value => moment(value).toDate();

export const fromNow = (value, pass = false) => moment(value).fromNow(pass);




// WEBPACK FOOTER //
// ./src/util/dateUtils.js